import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

const initialState: Offer = {
  OfferID: null,
  TenantID: null,
  CategoryName: '',
  CouponInstructions: '',
  CouponProvider: '',
  CouponType: '',
  CouponURLTemplate: null,
  Coupons: [],
  Description: '',
  DestinationUUID: '',
  EndTimestampUTC: '',
  Hidden: false,
  LimitTimeFrameInDays: null,
  RealValue: null,
  RedemptionsAllowedInTimeFrame: null,
  SourceType: '',
  StartTimestampUTC: '',
  Status: '',
  SubTitle: '',
  Title: '',
  UiPosition: null,
  VeloAmount: null,
  WebTitle: '',
  WebUiPosition: null,
  favoriteCount: null,
  offerImageUrl: '',
  incluededSegments: '',
  translationLanguageList: [],
  AvailableCouponsCount: '',
  RedeemedCouponsCount: '',
  HasRepeatableCoupons: null,
  ImageID: null,
  IconImageID: null,
  ProductUUID: null,
  MaxRedeemsPerUser: null,
  ProviderID: null,
  OriginUUID: null,
  RedemptionApiClient: null,
  TotalRedemptions: null,
  isFavorite: false,
  RevenueFee: null,
  RedemptionApiConfigurationID: null,
  selectedLanguage: '',
  selectedLanguageName: '',
  defaultLanguage: {
    Title: null,
    SubTitle: null,
    Description: null,
    CouponInstructions: null,
    TermsAndConditionsBody: null,
    TermsAndConditionsTitle: null
  },
  translations: {
    Title: null,
    SubTitle: null,
    Description: null,
    CouponInstructions: null,
    LanguageCode: null,
    TermsAndConditionsBody: null,
    TermsAndConditionsTitle: null
  },
  ProductName: '',
  ProductCurrencyCode: '',
  ProductAmount: null,
  ProductFareType: '',
  ProductDisclaimer: '',
  IsProductAvailable: false,
  IsAPIUpdated: false,
  CatalogSocketID: null,
  CatalogItemID: null,
  CatalogProductQuantity: null,
  IsCatalogReplenish: false,
  AmountOptionsToRedeem: null,
  MaxPointsToRedeem: null,
  MinPointsToRedeem: null,
  TermsAndConditionsBody: null,
  TermsAndConditionsTitle: null,
  TermsAndConditionsLink: null,
  CreatedAtUTC: null
}

export const offerSlice = createSlice({
  name: 'offer',
  initialState,
  reducers: {
    setOffer: (state, action: PayloadAction<Offer>) => {
      return action.payload
    },
    setOfferSelectedTranslations: (
      state,
      action: PayloadAction<SetOfferTranslationParms>
    ) => {
      return {
        ...state,
        selectedLanguage: action.payload.selectedLanguage,
        selectedLanguageName: action.payload.selectedLanguageName,
        defaultLanguage: action.payload.defaultLanguage,
        translations: {
          Title: action.payload.translations?.Title ?? null,
          SubTitle: action.payload.translations?.SubTitle ?? null,
          Description: action.payload.translations?.Description ?? null,
          CouponInstructions:
            action.payload.translations?.CouponInstructions ?? null,
          LanguageCode: action.payload.selectedLanguage,
          TermsAndConditionsBody:
            action.payload.translations?.TermsAndConditionsBody ?? null,
          TermsAndConditionsTitle:
            action.payload.translations?.TermsAndConditionsTitle ?? null
        }
      }
    }
  }
})

export const { setOffer, setOfferSelectedTranslations } = offerSlice.actions

export const offerReducer = offerSlice.reducer
